import { Controller } from "stimulus"
import moment from "moment"
import { csrfToken } from "../helpers"

export default class extends Controller {
  static classes = ["alert"]

  toggle(e) {
    e.preventDefault()
    const el = e.target

    // Ignore past days
    if (el.classList.contains("past")) {
      return
    }

    el.classList.remove("x-pop")

    if (el.classList.contains("selected")) {
      el.classList.remove("selected")
      this.performToggle(el, "remove")
      this.notifyUser(el.dataset.date, false)
    } else {
      el.classList.add("x-pop")
      el.classList.add("selected")
      this.performToggle(el, "add")
      this.notifyUser(el.dataset.date)
    }
  }

  async performToggle(el, type) {
    el.toggleAttribute("data-toggling", true)
    await this[`${type}Absence`](el.dataset.date)
    el.toggleAttribute("data-toggling", false)
  }

  addAbsence(date) {
    const options = {
      method: "post",
      headers: {
        "X-CSRF-Token": csrfToken(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        date: date,
      }),
    }
    return fetch(this.data.get("path"), options)
  }

  notifyUser(date, added = true) {
    let messageEl = document.getElementById(this.data.get("responseElId"))
    let contentsEl = document.createElement("div")

    if (added) {
      contentsEl.classList.add(
        "bg-success-50",
        "text-success-600",
        "dark:bg-success-400/[.15]",
        "dark:text-success-300"
      )
    } else {
      contentsEl.classList.add("bg-info-50", "text-info-600", "dark:bg-info-400/[.15]", "dark:text-info-300")
    }

    if (this.hasAlertClass) {
      contentsEl.classList.add(...split(this.alertClass))
    }

    contentsEl.innerHTML = `<p class="mb-0">${this.notifyUserMessage(date, added)}</p>`
    messageEl.innerHTML = ""
    messageEl.appendChild(contentsEl)
  }

  notifyUserMessage(date, added = true) {
    let fmDate = moment(date).isSame(moment(), "day")
      ? `Today, ${moment(date).format("dddd, MMMM D")}`
      : moment(date).format("dddd, MMMM D, YYYY")

    if (this.data.get("kind") == "preferences") {
      return added ? `${fmDate}, added as a planned absence.` : `${fmDate}, removed as a planned absence.`
    }

    if (this.data.get("kind") == "team") {
      return added
        ? `${fmDate}, added as a team holiday. Check-ins won't be collected.`
        : `${fmDate}, removed as a team holiday.`
    }

    return added
      ? `${fmDate}, added as a planned absence for ${this.data.get("kind")}. They won't be prompted for a check-in.`
      : `${fmDate}, removed as a planned absence for ${this.data.get("kind")}.`
  }

  removeAbsence(date) {
    const options = {
      method: "delete",
      headers: {
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify({
        date: date,
      }),
    }
    return fetch(`${this.data.get("path")}/${date}`, options)
  }
}

function split(string = "") {
  return string.match(/[^\s]+/g) || []
}
